import Vue from 'vue'
import state_config from './config'
import api from '@/api'
import VueLocalStorage from 'vue-localstorage'
import router from '@/router'
 
Vue.use(VueLocalStorage)

export default{
  loading: function({ commit, state }) {
    commit(state_config.LOADING) 
  },
  login: function({ commit, state }, creds) {
    commit(state_config.LOGIN) // show spinner
  	return new Promise((resolve, reject) => {
  		api.authDefault(creds,function(error, response){
  			if (error) {
          commit(state_config.LOGIN_FAIL)
          // console.log('error')
		      reject(error)
          return;
        }
        if (response.responsecode == 400) {
          resolve({
            code: response.responsecode,
            reason: response.reason
          })
        } else if (response.responsecode == 200) {

          state.botlist = response.botlist
          state.userid = creds.userid
          state.isFacebook = false
          state.accessToken = response.sessiontoken
  
          Vue.localStorage.set('botlist', JSON.stringify(state.botlist))
          Vue.localStorage.set('userid', state.userid)
          Vue.localStorage.set('token', state.accessToken)
          Vue.localStorage.set('FB', state.isFacebook)
  
          commit(state_config.LOGIN_SUCCESS)
          resolve({
            code: response.responsecode,
          })
        } else {
          // console.log('hi')
        }

  		})
    })
  },
  loginFB: function ({ commit, state, dispatch }, creds){
    commit(state_config.LOGIN) 
    return new Promise((resolve, reject) => {
      api.getLongLiveToken(creds,function(error, response){
        if (error) {
          commit(state_config.LOGIN_FAIL)
          reject(error)
          return;
        }

        api.getPageList({ token : response.longlivetoken },function(errorPageList, responsePageList){
          if (errorPageList) {
            commit(state_config.LOGIN_FAIL)
            reject(new Error(error))
          }

          let pagelist = []
          $.each(responsePageList,function(index, value){
            pagelist.push(value.id)
          })

          state.userid = creds.userid
          state.pagelist = responsePageList
          state.fbAccessToken = response.longlivetoken
          state.isFacebook = true

          Vue.localStorage.set('fbtoken', state.fbAccessToken)
          Vue.localStorage.set('userid', state.userid)
          Vue.localStorage.set('pagelist', JSON.stringify(state.pagelist))
          Vue.localStorage.set('FB', state.isFacebook)
          let data = { 
            userid : creds.userid ,
            pageidlist : pagelist,
            access_token: state.fbAccessToken
           }
          dispatch('getBotlist', data).then(response => {
            commit(state_config.LOGIN_SUCCESS)
            resolve()
          }, error => {
            commit(state_config.LOGIN_FAIL)
            reject(error)
          })
          
        })
      })
    })
  },
  updateNewBotlist: function ({ commit, state, dispatch}){
    return new Promise((resolve, reject) => {
      let pagelist = []
      $.each(state.pagelist, function (index, value) {
        pagelist.push(value.id)
      })

      let data = { 
        userid: state.userid, 
        pageidlist: pagelist,
        access_token: state.fbAccessToken
      }
      dispatch('getBotlist', data).then(response => {
        // commit(state_config.LOGIN_SUCCESS)
        if (state.selectedBot != null) {
          
          $.each(state.botlist,function(index, val){
            if (val.pageid == state.selectedBot.pageid) {
              dispatch('selectBot', val)
              return false
            }
          })
        }
        resolve()
      }, error => {
        // commit(state_config.LOGIN_FAIL)
        reject(error)
      })

    })
  },
  getBotlist: function ({ commit, state }, data) {
    return new Promise((resolve, reject) => {
      api.checkBotlist(data, function (error, response) {
        if (error) {
          reject(new Error(error))
        }

        // console.log(response)

        if (response.pageidlist) {
          let botlist = response.botlist
          state.botlist = botlist
          state.accessToken = response.sessiontoken

          Vue.localStorage.set('botlist', JSON.stringify(state.botlist))
          Vue.localStorage.set('token', state.accessToken)

        }
        resolve()

      })
    })
    
  } ,
  logout: function({ commit , state }, error) {
    return new Promise((resolve, reject) => {

      Vue.localStorage.remove('token')
      Vue.localStorage.remove('userid')
      Vue.localStorage.remove('botlist')
      Vue.localStorage.remove('selectedBot')
      Vue.localStorage.remove('fbtoken')
      // Vue.localStorage.remove('FB')
      Vue.localStorage.remove('pagelist')
      
      state.userid = null
      state.botlist = null
      state.selectedBot = null
      state.isSelectedBot = false
      // state.isFacebook = false
      state.accessToken = null
      state.fbAccessToken = null
      state.pagelist = null
      if (error) {
        state.systemError = error
      }
      if ($('.modal-backdrop')) {
        $('.modal-backdrop').remove()
      }
      commit(state_config.LOGOUT)

      resolve()

    })
  },
  selectBot: function({state , commit, dispatch}, bot) {
    if (state.selectedBot && bot && bot.pageid != state.selectedBot.pageid) {
      dispatch('updatePaypalTrackingId', null)
    }
    Vue.localStorage.set('selectedBot', JSON.stringify(bot))
    commit(state_config.SELECT_NEW_BOT,bot)
	  commit(state_config.SELECT_BOT)
  },
  unselectBot: function({state , commit, dispatch}) {
    dispatch('updatePaypalTrackingId', null)
    Vue.localStorage.remove('selectedBot')
    state.selectedBot = null
    state.isSelectedBot = false
  },
  updateBotlist: function({state , commit}, botlist) {
    state.botlist = botlist
    Vue.localStorage.set('botlist', JSON.stringify(state.botlist))
  },
  updatePagelist: function({state, commit}) {
    if (!state.isFacebook) {
      return false
    }
    api.getPageList({ token : state.fbAccessToken },function(error, response){
      if (error) {
        console.error(error)
        return false
      }

      state.pagelist = response
      Vue.localStorage.set('pagelist', JSON.stringify(state.pagelist))

      return true
    })
  },
  sidebar: function({ commit, state },value) {
    if (value) {
      // console.log(value)
      commit(state_config.SIDEBAR) 
    }
    commit(state_config.SIDEBAR) 
  },
  updatePaypalTrackingId: function({commit, state}, value){
    state.paypalTrackingId = value
    if (value == null) {
      Vue.localStorage.remove('paypalTrackingId')
    } else {
      Vue.localStorage.set('paypalTrackingId', state.paypalTrackingId)
    }
  },
  updateMerchantId: function ({ commit, state }, value){
    state.selectedBot.paypal_merchantid = value
    Vue.localStorage.set('selectedBot', JSON.stringify(state.selectedBot))
    commit(state_config.SELECT_NEW_BOT, state.selectedBot)
    commit(state_config.SELECT_BOT)
  },
  updateSetting: function({commit, state },value){
    commit(state_config.UPDATE_SETTING, value)
  },
  updateWelcomeMessage: function ({ commit, state },value){
    commit(state_config.UPDATE_WELCOME_MESSAGE, value)
  },
  updateBotDetail: function ({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {

      let data = { pageid: state.selectedBot.pageid }
      api.getBotDetail(data, function (error, response) {
        if (error) {
          reject(error)
          return;
        }

        if (response.data) {
          
          state.selectedBot.description = response.data.description
          state.selectedBot.expireat = response.data.expireat
          state.selectedBot.notify_admin = response.data.notify_admin
          state.selectedBot.ownerid = response.data.ownerid
          state.selectedBot.pageaddress = response.data.pageaddress
          state.selectedBot.pagelogo = response.data.pagelogo
          state.selectedBot.pagename = response.data.pagename
          state.selectedBot.pageshortlink = response.data.pageshortlink
          state.selectedBot.paypal_merchantid = response.data.paypal_merchantid
          state.selectedBot.persistent_menu = response.data.persistent_menu
          state.selectedBot.registerat = response.data.registerat
          state.selectedBot.status = response.data.status
          state.selectedBot.theme = response.data.theme

          Vue.localStorage.set('selectedBot', JSON.stringify(state.selectedBot))

          $.each(state.botlist,function(index, bot){
            if (bot.pageid == state.selectedBot.pageid) {
              state.botlist[index] = state.selectedBot
              Vue.localStorage.set('botlist', JSON.stringify(state.botlist))
              return false
            }
          })
        }


        resolve(response)


      })

    })
  },
  addModalWelcome: function ({ commit, state }) {
    commit(state_config.UPDATE_MODAL_WELCOME, true)
  },
  clearModalWelcome: function ({ commit,state }){
    commit(state_config.UPDATE_MODAL_WELCOME, false)
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js